// extracted by mini-css-extract-plugin
export var columnList = "_hz-0";